<template lang="pug">
  a-row(
    :gutter="15"
  )
    a-col(
      :xs="24"
      :sm="12"
      v-for="projectGroup in getProjectGroupsByNameOrProjectDescription()"
      :key="projectGroup.name"
    )
      project-group.mb-3(
        :projectGroup="projectGroup"
      )
</template>

<script>
import {
  mapState,
  mapGetters,
} from 'vuex';

import ProjectGroup from '@/components/ProjectGroup';

export default {
  components: {
    ProjectGroup,
  },
  computed: {
    ...mapState([
      'projectSearchText',
    ]),
    ...mapGetters([
      'projectGroups',
      'projectGroupsByNameOrProjectDescription',
    ]),
  },
  methods: {
    getProjectGroupsByNameOrProjectDescription() {
      return this.projectGroupsByNameOrProjectDescription(this.projectSearchText);
    },
  },
};
</script>
